import { AxiosRequestConfig } from 'axios'

export enum ApiServices {
  cinder = 'Cinder',
  clemency = 'Clemency',
  glance = 'Glance',
  keystone = 'Keystone',
  murano = 'Murano',
  neturon = 'Neutron',
  nova = 'Nova',
  kubernetes = 'Kubernetes',
  resmgr = 'ResMgr',
}

export interface DDUHealth {
  task_state: string
  desired_services: number
  ready_services: number
  service_details: { [key: string]: ServiceDetail }
}

export interface ServiceDetail {
  desired: number
  ready: number
}

export interface CustomerMetadata {
  [key: string]: any
}

interface IRequestOptions {
  clsName: string
  mthdName: string
  config?: any
  extractNestedData?: boolean
  mock?: boolean
  useJWTToken?: boolean
}
export interface IRawRequestGetParams {
  url: string
  version?: string
  endpoint?: string
  config?: AxiosRequestConfig
  options: IRequestOptions
}
export interface IRawRequestPostParams extends IRawRequestGetParams {
  data: any
}

export interface IBasicRequestGetParams {
  url: string
  version?: string
  params?: AxiosRequestConfig['params']
  endpoint?: string
  config?: AxiosRequestConfig
  options: IRequestOptions
  normalize?: boolean
}

export interface IBasicRequestPostParams {
  url: string
  version?: string
  body?: any
  endpoint?: string
  config?: AxiosRequestConfig
  options: IRequestOptions
}

export interface ApiErrorMetadata {
  isClusterError?: boolean
  k8sResource?: string
  k8sResourceName?: string
  k8sResourceAccessor?: string
  params?: any
}
export interface Method extends MethodMetadata {
  name: string
}

export interface MethodMetadata {
  url: string
  version?: string
  type: 'GET' | 'PUT' | 'PATCH' | 'POST' | 'DELETE'
  params?: string[]
  error?: ApiErrorMetadata
  disable?: boolean
}

export interface IBasicRequestDeleteParams {
  url: string
  version?: string
  params?: AxiosRequestConfig['params']
  data?: AxiosRequestConfig['data']
  endpoint?: string
  config?: AxiosRequestConfig
  options: IRequestOptions
}

export interface ApiResponseErrorModel {
  isClusterError: boolean
  apiClassMetadata: ApiClassMetadata
  apiErrorMetadata: ApiErrorMetadata
  response: Response
  stack: string
  err: string | { message: string }
  message?: string
}

interface ApiClassMetadata {
  apiClass: string
  requestMethod: string
}

interface Response {
  config: Config
  data: ResponseData | any
  status: number
  statusText: string
}

interface Config {
  url: string
  method: string
  data: any
  headers: Record<string, string>
}

interface ResponseData {
  status: string
  message: string
  code: number
  data: string
}

export type RetryVMHARequest = {
  vmha_uuid: string
  host_id: string
  vm_list: string[]
  az: string
}

export type RetryVMHAResponse = {
  phase: 'triggered' | 'error'
  reason: string
  vmha_uuid: string
}

export enum ClusterVmhaStatus {
  Protected = 'protected',
  Unprotected = 'unprotected',
  Degraded = 'degraded',
}

type VMHAStatus = ClusterVmhaStatus
type VMHATaskState = 'Failed' | 'Active'
type ConditionStatus = 'pass' | 'failed'

export enum VMHAConditionKey {
  TwoActiveHosts = 'TwoActiveHosts',
  TwoHostsPerAggregate = 'TwoHostsPerAggregate',
  SharedStorage = 'SharedStorage',
  ImageLibrary = 'ImageLibrary',
  PersistentStorage = 'PersistentStorage',
  HaSlaveStatus = 'HaSlaveStatus',
}

export interface VMHACondition {
  [VMHAConditionKey.TwoActiveHosts]: ConditionStatus
  [VMHAConditionKey.TwoHostsPerAggregate]: ConditionStatus
  [VMHAConditionKey.SharedStorage]: ConditionStatus
  [VMHAConditionKey.ImageLibrary]: ConditionStatus
  [VMHAConditionKey.PersistentStorage]: ConditionStatus
  [VMHAConditionKey.HaSlaveStatus]: ConditionStatus
}

export interface VMHAStatusDetails {
  name: string
  enabled: boolean
  vmha_status: VMHAStatus
  task_state?: VMHATaskState
  conditions?: VMHACondition
  exclude_ephemeral_vms?: boolean
}
